import { render, staticRenderFns } from "./Dotun.vue?vue&type=template&id=3675944a&scoped=true&"
import script from "./Dotun.vue?vue&type=script&lang=js&"
export * from "./Dotun.vue?vue&type=script&lang=js&"
import style0 from "./Dotun.vue?vue&type=style&index=0&id=3675944a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3675944a",
  null
  
)

export default component.exports